import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import type { WorkspaceAccount } from "common/types";

async function getAccountProxyRequest(
  workspaceId: string,
  accountId: string,
): Promise<string> {
  const { config } = await get(
    `workspaces/${workspaceId}/accounts/${accountId}/proxy`,
  );
  if ("custom_proxy_id" in config) {
    return config.custom_proxy_id;
  }
  return config["location.countryISO"].$eq;
}

export default function useAccountProxy(account: WorkspaceAccount) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { data: accountProxy, isLoading: isLoadingAccountProxy } = useQuery({
    queryKey: getQueryKeys(workspaceId).accountsKeys.proxy(account.id),
    queryFn: () => getAccountProxyRequest(workspaceId, account.id),
    enabled: account.type === "user",
  });

  return {
    accountProxy,
    isLoadingAccountProxy,
  };
}
